// extracted by mini-css-extract-plugin
export default {"leftToolBox":"App_leftToolBox__LaH2N","rightToolBox":"App_rightToolBox__xb1oE"};